import * as Styled from "./VendorFooter.styles";

import { ReactComponent as TaoRooamLogo } from "../../assets/tao-rooam-logo.svg";

export default function VendorFooter(): React.ReactElement {
  const year = new Date().getFullYear();
  return (
    <Styled.Container direction="column">
      <Styled.Logo>
        <TaoRooamLogo />
      </Styled.Logo>
      <span>
        Tao Group Hospitality Pay -{" "}
        <a href="https://rooam.co/" target="_blank" rel="noreferrer">
          Powered by Rooam
        </a>
      </span>
      <br />
      <span className="text-lighter">
        © Copyright {year} - Tao Group Hospitality.
      </span>
      <br />
      <span className="text-lighter">
        <a
          href="https://taogroup.com/website-terms-of-use/"
          target="_blank"
          rel="noreferrer"
        >
          Tao Group Hospitality Terms
        </a>
      </span>
    </Styled.Container>
  );
}
